import type { DocumentsAndRequestsFeatureConfig } from '../type';

export const documentsAndRequests: Partial<DocumentsAndRequestsFeatureConfig> = {
    documentsPackageDownload: true,
    operationAgnosticSigning: true,
    signingAlwaysVisible: true,
    caseTypeFilterVisible: true,
    cacheDuration: 30000,
};
